webpackJsonp([2925446298596113000],{

/***/ "./data/pages.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var config = __webpack_require__("./data/config.js");
	var root =  true ? config.pathPrefix ? config.pathPrefix + '/' : '/' : '/';
	
	module.exports = [{
			id: 'home',
			path: root,
			hero: {
					type: 'jumbo',
					figure: true,
					image: {
							type: 'logo'
					},
					headline: {
							type: 'centered',
							level: 1,
							title: true,
							caption: true
					}
			},
			cta: {
					type: 'centered'
			},
			listing: {
					type: 'posts',
					figure: true,
					button: {
							type: 'primary link',
							label: 'View All Updates'
					},
					prefix: '/updates',
					headline: {
							level: 1,
							title: 'Latest Update'
					}
			},
			heel: {
					type: 'fluid'
			}
	}, {
			id: 'about',
			path: root + 'about',
			hero: {
					figure: true,
					headline: {
							level: 1,
							title: 'What is Castmaker?',
							caption: true
					}
			},
			content: {
					type: 'markdown',
					figure: true
			},
			cta: {
					type: 'centered'
			},
			heel: {
					type: 'fluid'
			}
	}, {
			id: 'updates',
			path: root + 'updates',
			hero: {
					figure: true,
					headline: {
							level: 1,
							title: 'Development Updates',
							caption: 'These are the documents of our product\'s entire life cycle'
					}
			},
			listing: {
					type: 'posts',
					figure: 'posts',
					prefix: '/updates'
			},
			cta: {
					type: 'centered'
			},
			heel: {
					type: 'fluid'
			}
	}];

/***/ }),

/***/ "./src/containers/seo/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__("./data/config.js");
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var postURL = void 0;
	    if (postSEO) {
	      var postMeta = postNode.frontmatter;
	      title = postMeta.title;
	      description = postMeta.description ? postMeta.description : postNode.excerpt;
	      image = postMeta.cover;
	      postURL = _config2.default.siteUrl + _config2.default.pathPrefix + postPath;
	    } else {
	      title = _config2.default.siteTitle;
	      description = _config2.default.siteDescription;
	      image = _config2.default.siteLogo;
	    }
	    var realPrefix = _config2.default.pathPrefix === "/" ? "" : _config2.default.pathPrefix;
	    image = _config2.default.siteUrl + realPrefix + image;
	    var blogURL = _config2.default.siteUrl + _config2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      '@context': 'http://schema.org',
	      '@type': 'WebSite',
	      url: blogURL,
	      name: title,
	      alternateName: _config2.default.siteTitleAlt ? _config2.default.siteTitleAlt : ''
	    }];
	    if (postSEO) {
	      schemaOrgJSONLD.push([{
	        '@context': 'http://schema.org',
	        '@type': 'BreadcrumbList',
	        itemListElement: [{
	          '@type': 'ListItem',
	          position: 1,
	          item: {
	            '@id': postURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        '@context': 'http://schema.org',
	        '@type': 'BlogPosting',
	        url: blogURL,
	        name: title,
	        alternateName: _config2.default.siteTitleAlt ? _config2.default.siteTitleAlt : '',
	        headline: title,
	        image: {
	          '@type': 'ImageObject',
	          url: image
	        },
	        description: description
	      }]);
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('meta', { name: 'description', content: description }),
	      _react2.default.createElement('meta', { name: 'image', content: image }),
	      _react2.default.createElement(
	        'script',
	        { type: 'application/ld+json' },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement('meta', { property: 'og:url', content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement('meta', { property: 'og:type', content: 'article' }) : null,
	      _react2.default.createElement('meta', { property: 'og:title', content: title }),
	      _react2.default.createElement('meta', { property: 'og:description', content: description }),
	      _react2.default.createElement('meta', { property: 'og:image', content: image }),
	      _react2.default.createElement('meta', { property: 'fb:app_id', content: _config2.default.siteFBAppID ? _config2.default.siteFBAppID : '' }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', { name: 'twitter:creator', content: _config2.default.userTwitter ? _config2.default.userTwitter : '' }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: image })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dvz/Projects/gatsby-castmaker/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-plugin-lodash/lib/index.js\",\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/updates.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _capitalize2 = __webpack_require__("./node_modules/lodash/capitalize.js");
	
	var _capitalize3 = _interopRequireDefault(_capitalize2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _seo = __webpack_require__("./src/containers/seo/index.jsx");
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _hero = __webpack_require__("./src/containers/hero/index.jsx");
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _listing = __webpack_require__("./src/containers/listing/index.jsx");
	
	var _listing2 = _interopRequireDefault(_listing);
	
	var _cta = __webpack_require__("./src/containers/cta/index.jsx");
	
	var _cta2 = _interopRequireDefault(_cta);
	
	var _heel = __webpack_require__("./src/containers/heel/index.jsx");
	
	var _heel2 = _interopRequireDefault(_heel);
	
	var _mailchimp = __webpack_require__("./src/components/mailchimp/index.jsx");
	
	var _mailchimp2 = _interopRequireDefault(_mailchimp);
	
	var _social_links = __webpack_require__("./src/components/social_links/index.jsx");
	
	var _social_links2 = _interopRequireDefault(_social_links);
	
	var _counter = __webpack_require__("./src/components/counter/index.jsx");
	
	var _counter2 = _interopRequireDefault(_counter);
	
	var _config = __webpack_require__("./data/config.js");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _pages = __webpack_require__("./data/pages.js");
	
	var _pages2 = _interopRequireDefault(_pages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var path = void 0;
	if (true) {
	  path = _config2.default.pathPrefix ? '' + _config2.default.pathPrefix + _config2.default.blogPostPrefix : _config2.default.blogPostPrefix;
	} else {
	  path = _config2.default.blogPostPrefix;
	}
	
	var UpdatesIndex = function (_React$Component) {
	  _inherits(UpdatesIndex, _React$Component);
	
	  function UpdatesIndex() {
	    _classCallCheck(this, UpdatesIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  UpdatesIndex.prototype.componentWillMount = function componentWillMount() {
	    var data = this.props.data;
	
	    var posts = data.allMarkdownRemark.edges;
	
	    var updates = posts.filter(function (post) {
	      return post.node.frontmatter.type === 'post';
	    });
	
	    var page = _pages2.default.filter(function (page) {
	      return page.path === path;
	    })[0];
	
	    this.page = page;
	    this.updates = updates;
	  };
	
	  UpdatesIndex.prototype.getPageConfig = function getPageConfig() {
	    return this.page;
	  };
	
	  UpdatesIndex.prototype.getUpdates = function getUpdates() {
	    return this.updates;
	  };
	
	  UpdatesIndex.prototype.render = function render() {
	    var page = this.getPageConfig();
	    var posts = this.getUpdates();
	
	    return _react2.default.createElement(
	      'div',
	      { className: page.id + ' page' },
	      _react2.default.createElement(_reactHelmet2.default, { title: (0, _capitalize3.default)(page.id) + ' | ' + _config2.default.siteTitle }),
	      _react2.default.createElement(_seo2.default, { postEdges: posts }),
	      _react2.default.createElement(_hero2.default, { figure: page.hero.figure,
	        title: page.hero.headline.title,
	        caption: page.hero.headline.caption }),
	      _react2.default.createElement(_listing2.default, { type: page.listing.type,
	        figure: page.listing.figure,
	        prefix: page.listing.prefix,
	        button: page.listing.button,
	        headline: page.listing.headline,
	        list: posts }),
	      _react2.default.createElement(
	        _cta2.default,
	        { type: page.cta.type },
	        _react2.default.createElement(_mailchimp2.default, { figure: true,
	          title: _config2.default.subscribeTitle,
	          caption: _config2.default.subscribeCaption,
	          action: _config2.default.mailchimpAction,
	          disclaimer: _config2.default.subscribeDisclaimer }),
	        _react2.default.createElement(_social_links2.default, { links: _config2.default.userLinks })
	      ),
	      _react2.default.createElement(
	        _heel2.default,
	        { type: page.heel.type },
	        _react2.default.createElement(_counter2.default, { type: page.heel.type,
	          title: _config2.default.countdownTitle,
	          date: _config2.default.countdownDate,
	          message: _config2.default.counterMessage })
	      )
	    );
	  };
	
	  return UpdatesIndex;
	}(_react2.default.Component);
	
	exports.default = UpdatesIndex;
	
	/* eslint no-undef: "off"*/
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-updates-jsx-c1e568a2e1ed5b7d4822.js